import React, { SFC } from 'react';
import styled from 'styled-components';
import { NewProductFilterValues } from '../../../redux/products/types';
import CheckBox from '../../Generic/Input/CheckBox';
import { FilterValue } from './filterValueService';
import { ListFiltersLayout, CountLabel } from './CommonFilterElements';

export interface StandardFilterGroupProps {
    filterOptions: { [name: string]: number };
    value: FilterValue;
    name: string;
    handleValueChange: (value: NewProductFilterValues) => void;
}

export const StyledFilterItemWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
`;

const StandardFilterGroup: SFC<StandardFilterGroupProps> = ({ filterOptions, value, name, handleValueChange }) => {
    const currentValue = Array.isArray(value) ? value : [];
    const handleCheckBoxValueChange = (newValue: string) => {
        const index = currentValue.map(current => current.toLocaleLowerCase()).indexOf(newValue.toLocaleLowerCase());
        if (index > -1) {
            currentValue.splice(index, 1);
        } else {
            currentValue.push(newValue);
        }

        handleValueChange({ name, value: currentValue });
    };

    return (
        <ListFiltersLayout>
            {Object.keys(filterOptions).map(item => (
                <StyledFilterItemWrapper key={item}>
                    <CheckBox
                        text={item}
                        value={item}
                        isChecked={currentValue
                            .map(current => current.toLocaleLowerCase())
                            .includes(item.toLocaleLowerCase())}
                        onChange={(_, urlKey) => handleCheckBoxValueChange(urlKey)}
                    />
                    <CountLabel count={filterOptions[item]} />
                </StyledFilterItemWrapper>
            ))}
        </ListFiltersLayout>
    );
};

export default StandardFilterGroup;
